import { Button, CardGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import {
  DATA_CARD_ONE_BANNER,
  DATA_CARD_ONE_LOGO_DEFAULT,
  DATA_CARD_ONE_VIEWER_DEFAULT,
  INTERACT_VIEWER,
  STATISTICS_BANNER,
} from "../../../assets";
import { DATA } from "../../../constants/commond";
import { HOME, STATISTICS } from "../../../constants/routes";
import { CustomBreadcrumb, FeatureCard } from "../../moleculas";
import CategoryGrid from "./categoryGrid";
import GeoenvironmentalSection from "../About/GeoenvironmentalSection";
import { useParams } from "react-router-dom";
import LogosSection from "./logoContainer";
import { useState } from "react";
import { CARD_LIST_V2 } from "../../../constants/open-data";
import React from "react";

const STATIC_IMAGE_DEFAULT = DATA_CARD_ONE_BANNER;

function TwoLineText({ text }: { text: string }) {
  const parts = text.split("<sep>");
  return (
    <h2>
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          {p.trim()}
          {i < parts.length - 1 && <br />}
        </React.Fragment>
      ))}
    </h2>
  );
}

const CardDetailDescription = () => {
  const instructionCards = DATA.statisticsSection.instructionCards;
  const { t } = useTranslation("statistics");
  const { id } = useParams();
  const [data, setData] = useState(
    CARD_LIST_V2.find((element) => element.id === id)
  );
  return (
    <div className="w-100 d-flex justify-content-center flex-column align-items-center pb-5 statistics-description">
      <div
        style={{ overflow: "hidden" }}
        className="d-flex w-100 statistics-description-background justify-content-end"
      >
        <img
          style={{ marginTop: -45 }}
          src={STATIC_IMAGE_DEFAULT}
          alt="statistics-banner"
        />
      </div>
      <div className="w-75 mb-5 d-flex flex-column align-items-center statistics-description-text">
        <div className="w-100 align-items-left">
          <CustomBreadcrumb
            isWhite={false}
            breadcrumbs={[
              {
                name: t("home"),
                href: HOME,
              },
              {
                name: data?.name ? data?.name : "",
                href: data?.open_data_link,
              },
            ]}
          />
          <div className="d-flex flex-column col-sm col-md-12 mb-2">
            <TwoLineText text={data?.title ? data?.title : ""} />

            <hr className="custom-divider" />
            <div className="col-lg-5 col-12">
              <div className="mb-3">{data?.description}</div>
              {data?.bannerImageSrc && (
                <img src={DATA_CARD_ONE_LOGO_DEFAULT} alt="logo-banner" />
              )}
            </div>
          </div>
        </div>
      </div>
      <br />

      <div className="w-100 d-flex flex-column align-items-center background-color mt-5 mt-sm-5">
        <div className="w-75">
          {data?.elements && <CategoryGrid items={data?.elements} />}
        </div>
      </div>
      <div
        style={{ backgroundColor: "white" }}
        className="w-100 d-flex flex-column align-items-center background-color mt-5 "
      >
        <div className="w-75 ">
          {data?.whereWorkdShow && (
            <div className="w-100 mb-5">
              <div className="row">
                <div
                  style={{ alignContent: "center" }}
                  className="col-sm-12 col-lg-6 p-5"
                >
                  <h1>Donde Trabajamos</h1>
                  <hr className="custom-divider" />
                  <p>
                    El Gran Ecosistema Marino del Pacífico Costero
                    Centroamericano (GEM PACA) se extiende por 9 países desde el
                    sur de México hasta el Golfo de Guayaquil. Los países
                    participantes en este proyecto son México, Guatemala,
                    Honduras, Costa Rica, Panamá, Colombia y Ecuador. El
                    proyecto ha priorizado zonas de intervención en la región
                    PACA con base en las acciones piloto que abordan cuestiones
                    clave comunes.
                  </p>
                  <div className="mt-4">
                    <Button className="custom-primary-button">
                      VER VISOR DE DATOS
                    </Button>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-6 mt-3 mt-sm-5">
                  <img
                    className="img-fluid shadow"
                    src={DATA_CARD_ONE_VIEWER_DEFAULT}
                  ></img>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <div className="w-100 d-flex flex-column align-items-center background-color mt-5 mt-sm-5">
        {/* <div className="w-75 mb-5">
          <LogosSection
            logos={[
              "https://placehold.co/120x60?text=Logo1",
              "https://placehold.co/120x60?text=Logo2",
              "https://placehold.co/120x60?text=Logo3",
              "https://placehold.co/120x60?text=Logo4",
              "https://placehold.co/120x60?text=Logo5",
            ]}
          />
        </div> */}
        <div className="w-75 mt-5">
          <GeoenvironmentalSection />
        </div>
      </div>
    </div>
  );
};

export default CardDetailDescription;
